module.exports = __webpack_public_path__ + "img/header-th.35ba2080.png";